import { useCallback, useEffect, useRef, useState } from 'react';
import React from 'react';
import { useWebSocket } from '../contexts/WebSocketContext';

export function useTypingChannel(otherId) {
  const { lastMessage, sendMessage } = useWebSocket();
  const [otherTyping, setOtherTyping] = useState(false);
  const timerRef = useRef(null);
  const sentRef = useRef(0);

  useEffect(() => {
    if (!lastMessage || !otherId) return;
    const sid = String(lastMessage.sender_id || lastMessage.message?.sender_id || '');
    if (sid !== String(otherId)) return;
    if (lastMessage.type === 'typing') {
      setOtherTyping(true);
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setOtherTyping(false), 3500);
    } else if (lastMessage.type === 'stop_typing' || lastMessage.type === 'new_message') {
      clearTimeout(timerRef.current);
      setOtherTyping(false);
    }
  }, [lastMessage, otherId]);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const emitTyping = useCallback(() => {
    if (!otherId) return;
    const now = Date.now();
    if (now - sentRef.current > 2000) {
      sentRef.current = now;
      sendMessage({ type: 'typing', recipient_id: otherId });
    }
  }, [otherId, sendMessage]);

  const emitStopTyping = useCallback(() => {
    if (!otherId) return;
    sentRef.current = 0;
    sendMessage({ type: 'stop_typing', recipient_id: otherId });
  }, [otherId, sendMessage]);

  return { otherTyping, emitTyping, emitStopTyping };
}

export function TypingDots() {
  return (
    <div className="flex justify-start" data-testid="typing-indicator">
      <div className="bg-white border border-slate-200 rounded-2xl rounded-bl-sm px-3.5 py-2.5 shadow-sm inline-flex items-center gap-1">
        <span className="w-1.5 h-1.5 bg-slate-400 rounded-full animate-bounce" />
        <span className="w-1.5 h-1.5 bg-slate-400 rounded-full animate-bounce" style={{ animationDelay: '0.15s' }} />
        <span className="w-1.5 h-1.5 bg-slate-400 rounded-full animate-bounce" style={{ animationDelay: '0.3s' }} />
      </div>
    </div>
  );
}
